export const replaceDraftData = (value: string, mockValue: string = 'Draft') => {
  if (value.includes(mockValue)) {
    return value.replace(mockValue, '');
  }
  return value;
};